Namespace 'Process'
class Process.ProcessExecution extends Backbone.Model

  cancel: ->
    $.ajax
      method: 'POST'
      url: @url() + '/cancel'
      success: (response) =>
        @set("status", "Canceled") if response.success

  delete: ->
    @destroy()

class Process.ProcessExecutionCollection extends Backbone.Collection
  model: Process.ProcessExecution
  url: '/reports/process_executions'
  parse: (data) ->
    data.reports
